export const vueLaravelErrors = (type) => {
    return {
        data() {
            return {
                errors: {},
            }
        },
        computed: {
            errosCamposFixos(){
                return Object.entries(this.errors)
                    .filter(item => item[0].includes('dados_validador'))
                    .map(item => item[1])
            },
        },
        methods: {
            fillErrors(errors) {
                if (type === 'array') {
                    errors = Object.entries(errors);
                    errors = errors.flatMap(error => {
                        return [...error[1]];
                    })
                } else if (type === 'object') {
                    errors = Object.entries(errors);
                    errors = errors.map(error => {
                        let key = error[0];
                        let value = error[1][0];
                        return {
                            [key]: value
                        };
                    })
                        .reduce((acc, current) => {
                            acc = Object.assign(acc, current);
                            return acc;
                        });
                }
                this.errors = errors;
                this.scrollToFirstErrorMessage();
            },
            hasError(error){
                if(type === 'object'){
                    return error in this.errors ?? false;
                }
                return false;
            },
            getError(error){
                if(type === 'object'){
                    return this.errors[error] ?? '';
                }
                return '';
            },
            sincronizarLivewire(keys, livewire){
                keys.forEach((key) => {
                    livewire.set(key, this.$data[key]);
                })
                this.errors = {};
                livewire.call('salvar')
            },
            verificarNaoSabe() {
                console.error('verificarNaoSabe não está definido para este tipo de pergunta')
            },
            verificarNaoSeAplica() {
                console.error('verificarNaoSeAplica não está definido para este tipo de pergunta')
            },
            scrollToFirstErrorMessage(){
                setTimeout(() => {
                    let mensagemErroValidacao = $('.invalid-feedback').first();
                    if (mensagemErroValidacao.offset()) {
                        $('.column-right').scrollTop(mensagemErroValidacao.offset().top);
                    }
                }, 150)
            },
        },
    }
}
